import { Formik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import Input from "../../components/input";
import TextArea from "../../components/textArea";
import { t } from "i18next";
import Button from "../../components/button";
import ArrowRight from "../../assets/icons/arrow-right.png"

const ContactUs=()=> {
    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("FirstName is required."),
        lastName: Yup.string().required("LastName is required."),
        email: Yup.string().email().trim().required("Email is required."),
        phone: Yup.string().required("Phone is required."),
        comment: Yup.string().required("Text is required."),
    });

    const initialValues = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        comment: "",
    };
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (values: any) => { }

    return (
        <section id="contactUs" className="home-container !bg-contact-layer !h-auto ">
        <div className="px-16 xs:px-4 py-12 space-y-16">
            <div className="flex flex-row xs:flex-col items-center justify-between gap-8 ">
                <h5 className="text-[87px] xs:text-4xl xs:font-semibold text-white !leading-none flex items-center gap-6 w-full">Let's Talk <br className="sm:hidden" /> with us <img className="w-[50px] h-[50px]" src={ArrowRight} alt="" /></h5>
                <div className="h-full flex items-center w-full relative top-[-100px] xs:top-auto">
                    <div className="bg-white rounded w-full  p-8 !shadow-2xl ">
                        <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleLogin}
                            validateOnBlur
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleSubmit,
                                setFieldTouched,
                                setFieldValue,
                                isSubmitting,
                                handleChange,
                                handleBlur,
                            }) => {
                                return (
                                    <form className="space-y-6" onSubmit={handleSubmit}>
                                        <div className="grid grid-cols-2 items-center gap-6">

                                            <Input
                                                //   label={t("FirstName")}
                                                containerClass="w-full"
                                                placeholder={t("First name")}
                                                name="firstName"
                                                error={errors.firstName}
                                                touched={touched.firstName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                variant="solid"
                                            />
                                            <Input
                                                //   labelClassName="text-base font-medium inline-block"
                                                containerClass="w-full"
                                                placeholder={t("LastName")}
                                                name="lastName"
                                                error={errors.lastName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                touched={touched.lastName}
                                                variant="solid"
                                            />
                                        </div>

                                        <div className="grid grid-cols-2 items-center gap-6">

                                            <Input
                                                //   label={t("Email ID")}
                                                containerClass="w-full"
                                                placeholder={t("Email ID")}
                                                name="email"
                                                error={errors.email}
                                                touched={touched.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                variant="solid"
                                            />
                                            <Input
                                                //   label={t("Password")}
                                                containerClass="w-full"
                                                placeholder={t("Phone")}
                                                name="phone"
                                                //   type="password"
                                                error={errors.phone}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                touched={touched.phone}
                                                variant="solid"
                                            />
                                        </div>

                                        <TextArea
                                            //   label={t("Password")}
                                            containerClass="w-full"
                                            placeholder={t("Start typing here...")}
                                            name="phone"
                                            rows={10}
                                            //   type="password"
                                            error={errors.comment}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            touched={touched.comment}
                                            variant="solid"
                                        />

                                        <Button
                                            className="ml-0 block  w-auto bg-blue mt-4 mb-3"
                                            type="submit"
                                            loading={isLoading}
                                        >
                                            {t("Submit")}
                                        </Button>

                                    </form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>

                {/* <p className=" text-xl text-lightGrey !leading-normal pt-6">- First time customers start as high as 89% cash-back on Visa and Mastercard gift cards, and it only goes up from there.</p> */}
                {/* <img className="w-full h-full mt-5" src={GiftCard} alt="" /> */}
            </div>
        </div>
    </section>
    )
}

export default ContactUs;